import { cn } from "@/lib/utils";
import Image from "next/image";

const ANIMATION_TEXTURE_SRC = "/assets/steam-onboarding/animation-texture.png";
const ANIMATION_MASK_SRC = "/assets/steam-onboarding/animation-mask.svg";

export const AnimatedEffect = ({
  className = "",
  tint,
}: {
  className?: string;
  tint: string;
}) => {
  return (
    <>
      <div
        className={cn("relative w-full h-full mask", className)}
        // tailwind v3 doesnt support mask properties :sadge:
        style={{
          maskImage: `url('${ANIMATION_MASK_SRC}')`,
          WebkitMaskImage: `url('${ANIMATION_MASK_SRC}')`,
          maskSize: "contain",
          maskPosition: "center",
          maskRepeat: "no-repeat",
        }}
      >
        <Image
          src={ANIMATION_TEXTURE_SRC}
          alt=""
          width={400}
          height={400}
          className="w-full h-full"
        />
        <div
          className="absolute inset-0"
          style={{
            mixBlendMode: "hue",
            backgroundColor: tint,
          }}
        />
      </div>
    </>
  );
};
